import { useState, type FC } from "react";
import { Button } from "../../components/ui/button";
import { Card } from "../../components/ui/card";
import { Activity } from "lucide-react";
import { useNavigate } from "react-router-dom";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import SessionStorageHelper from "../../utils/sessionStorageHelper";

const Dietpage: FC = () => {
  const navigate = useNavigate();
  const [selectedDiet, setSelectedDiet] = useState<string>("");

  const diets = [
    { title: "Classic", value: "classic" },
    { title: "Vegetarian", value: "vegetarian" },
    { title: "Vegan", value: "vegan" },
    { title: "Pescatarian", value: "pescatarian" },
    { title: "Low Carb / Keto", value: "low_carb_keto" },
  ];

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header */}
        <div className="space-y-4 p-4">
          {/* Logo */}
          <div className="flex items-center justify-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-blue-500 to-orange-400">
              <Activity className="h-5 w-5 text-white" />
            </div>
            <span className="text-lg font-semibold text-slate-500">
              Bite Balance
            </span>
          </div>

          {/* Assessment Progress */}
          <p className="text-center text-sm text-muted-foreground">
            Assessment 9 of 12
          </p>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto px-6 py-2">
          <div className="mb-8 space-y-2">
            <h1 className="text-3xl font-bold text-foreground sm:text-4xl">
              Do You Follow A Specific Diet?
            </h1>
            <p className="text-sm text-muted-foreground">
              Select your diet preference
            </p>
          </div>

          <div className="space-y-3">
            {diets.map(diet => (
              <Card
                key={diet.value}
                className={`cursor-pointer transition-all ${
                  selectedDiet === diet.value
                    ? "border-2 border-primary bg-primary/5"
                    : "border-2 border-border hover:border-primary/50"
                }`}
                onClick={() => setSelectedDiet(diet.value)}
              >
                <div className="flex items-center justify-between p-4">
                  <span className="text-lg font-semibold text-foreground">
                    {diet.title}
                  </span>
                  <div
                    className={`flex h-6 w-6 items-center justify-center rounded-full border-2 ${
                      selectedDiet === diet.value
                        ? "border-primary bg-primary"
                        : "border-muted-foreground"
                    }`}
                  >
                    {selectedDiet === diet.value && (
                      <div className="h-3 w-3 rounded-full bg-primary-foreground" />
                    )}
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Footer Button */}
        <div className="pb-safe border-t p-4">
          <Button
            onClick={() => {
              if (selectedDiet) {
                SessionStorageHelper.saveField("diet_adherence", selectedDiet);
                navigate("/glucera" + GluceraNavigationRoutes.EATMEALPAGE);
              }
            }}
            disabled={!selectedDiet}
            className="h-11 w-full rounded-xl bg-gradient-primary text-sm hover:opacity-90 disabled:opacity-50 sm:h-12 sm:text-base"
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Dietpage;
